// Validation e-mail volontairement simple côté client : le backend
// applique la validation faisant foi (zod `.email()`). Ici on veut juste
// éviter d'envoyer une valeur manifestement invalide et donner un retour
// immédiat au visiteur.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}
